import React from "react";
import { Box, ImageList, ImageListItem } from "@mui/material";
import { PageLayout } from "../../components/PageLayout/PageLayout";
import Seo from "../../components/Seo/Seo";
import { PAGE_SEO } from "../../seo/seoConstants";
import WhatsAppInfoSection from "../../components/WhatsAppInfoSection/WhatsAppInfoSection";
import { IMAGE_LIST_COLS, IMAGE_LIST_GAP, WHATSAPP_INFO } from "../shared/constants";
import { CommonBoxStyles, ServiceImage } from "../shared/styledComponents";
import { resolveAssetUrl } from "../../utils/assets";

// Bucket keys, not URLs (EB-514) — resolved at render time.
const PREFIX = "detalle-pagina-reparacion-de-computadores";

const images = [
  `${PREFIX}/banner-reparacion-de-computadores.jpg`,
  `${PREFIX}/flujo-de-reparacion-de-computadores.jpg`,
  `${PREFIX}/condiciones-de-servicio-de-reparaciones-1.png`,
  `${PREFIX}/condiciones-de-servicio-de-reparaciones-2.png`,
];

export const ComputerRepairing: React.FC = () => {
  return (
    <PageLayout>
      <Seo {...PAGE_SEO["/reparacion-de-computadores"]} />
      <CommonBoxStyles>
        <Box px={2}>
          <ImageList cols={IMAGE_LIST_COLS} gap={IMAGE_LIST_GAP}>
            {images.map((src, index) => (
              <ImageListItem key={index}>
                <ServiceImage
                  src={resolveAssetUrl(src)}
                  alt={`computer-repair-${index}`}
                  loading="lazy"
                />
              </ImageListItem>
            ))}
          </ImageList>
        </Box>
      </CommonBoxStyles>
      <WhatsAppInfoSection {...WHATSAPP_INFO.computerRepair} />
    </PageLayout>
  );
};

export default ComputerRepairing;
